import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import fr from './locales/fr';
import en from './locales/en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        translation: fr,
        ...fr
      },
      en: {
        translation: en,
        ...en
      },
    },
    defaultNS: 'translation',
    fallbackNS: ['common', 'navigation', 'dashboard', 'admin', 'auth', 'teleconsultation', 'notifications', 'clinic'],
    fallbackLng: 'fr',
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false, // React gère déjà la protection XSS
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'ekose_rx_locale',
      caches: ['localStorage'],
    },
  });

export default i18n;
